<template>
  <div class="vehicle-operateImpactFactors">
    <div class="module-title">网约运营态度</div>
    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 昨日平均出车时长 -->
        <HorizontalCardStyle1
          :title="workDurationData.title"
          :dataDesc="workDurationData.dataDesc"
          :dataUpdateTime="workDurationData.dataUpdateTime"
          :primaryDataList="workDurationData.primaryDataList"
          :secondaryDataList="workDurationData.secondaryDataList"
        />
      </el-col>
    </el-row>

    <!-- 昨日出车时长分布 -->
    <GradeBar
      class="mb16"
      :title="workDurationDistributionData.title"
      :dataDesc="workDurationDistributionData.dataDesc"
      :dataUpdateTime="workDurationDistributionData.dataUpdateTime"
      :legendsData="workDurationDistributionData.legendsData"
      :data="workDurationDistributionData.data"
      :tooltip="workDurationDistributionData.tooltip"
    />

    <div class="module-title">网约运营效率</div>
    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 平均TPH -->
        <HorizontalCardStyle2
          :title="tphData.title"
          :dataDesc="tphData.dataDesc"
          :dataUpdateTime="tphData.dataUpdateTime"
          :primaryDataList="tphData.primaryDataList"
          :secondaryDataList="tphData.secondaryDataList"
        />
      </el-col>
      <el-col :span="12">
        <!-- 平均IPH -->
        <HorizontalCardStyle2
          :title="iphData.title"
          :dataDesc="iphData.dataDesc"
          :dataUpdateTime="iphData.dataUpdateTime"
          :primaryDataList="iphData.primaryDataList"
          :secondaryDataList="iphData.secondaryDataList"
        />
      </el-col>
    </el-row>

    <!-- 昨日TPH分布 -->
    <GradeBar
      :title="tphDistributionData.title"
      :dataDesc="tphDistributionData.dataDesc"
      :dataUpdateTime="tphDistributionData.dataUpdateTime"
      :legendsData="tphDistributionData.legendsData"
      :data="tphDistributionData.data"
      :tooltip="tphDistributionData.tooltip"
    />
  </div>
</template>
<script>
import HorizontalCardStyle1 from '@/bizComponents/Dashboard/cards/horizontalCard/style1.vue'
import HorizontalCardStyle2 from '@/bizComponents/Dashboard/cards/horizontalCard/style2.vue'
import GradeBar from '@/bizComponents/Dashboard/gradeBar'
// eslint-disable-next-line import/no-cycle
import { getVehicleOperateImpactFactors } from '@/api/domain/vehicle'
import { WORK_DURATION_LIST, TPH_LIST } from '../../../carOperate/list/config'

export default {
  components: {
    HorizontalCardStyle1,
    HorizontalCardStyle2,
    GradeBar,
  },
  provide() {
    return {
      ratioConfig: {
        showRatio: true,
      },
    }
  },
  data() {
    const { spId = '' } = this.$route.query

    return {
      spId,
      // 昨日平均出车时长
      workDurationData: {
        title: '昨日平均出车时长',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 昨日出车时长分布
      workDurationDistributionData: {
        title: '昨日出车时长分布',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        legendsData: [],
        data: [],
        tooltip: `查询日期当天，出车车辆的出车时长分布情况：<br/>
        极少：【0，3）小时<br/>
        较少：【3，6）小时<br/>
        一般：【6，8）小时<br/>
        较多：【8，10）小时<br/>
        极多：【10，24】小时`,
      },
      // 平均TPH
      tphData: {
        title: '平均TPH',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 平均IPH
      iphData: {
        title: '平均IPH',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 昨日TPH分布
      tphDistributionData: {
        title: '昨日TPH分布',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        legendsData: [],
        data: [],
        tooltip: `查询日期当天，车辆TPH的分布情况：<br/>
          极低：【0，0.5）<br/>
          较低：【0.5，1）<br/>
          一般：【1，1.5）<br/>
          较高：【1.5，2）<br/>
          极高：【2以上】`,
      },
    }
  },
  created() {
    this.getVehicleOperateImpactFactors()
  },
  methods: {
    toVehicleOperateList(params = {}) {
      const spId = this.spId !== '' ? this.spId : undefined

      const routeData = this.$router.resolve({
        path: '/vehicle/linkage/carOperate/list',
        query: {
          spId,
          ...params,
        },
      })

      window.open(routeData.href, '_blank')
    },
    async getVehicleOperateImpactFactors() {
      let res

      try {
        res = await getVehicleOperateImpactFactors({
          spId: this.spId,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1) {
        // 昨日平均出车时长
        this.workDurationData.dataUpdateTime = data?.updateTime || ''
        this.workDurationData.primaryDataList = [
          {
            label: '昨日平均出车时长(小时)',
            value: data?.operateAttitude?.yesterdayAveWorkDurationInfo?.value || '--',
            unit: '',
            tooltip: `查询日期当天，出车车辆的平均出车时长等级：<br/>
            极少：【0，3）小时<br/> 
            较少：【3，6）小时<br/>
            一般：【6，8）小时<br/> 
            较多：【8，10）小时<br/> 
            极多：【10，24】小时`,
            ratioList: [
              {
                name: '日环比',
                value: data?.operateAttitude?.yesterdayAveWorkDurationInfo?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.operateAttitude?.yesterdayAveWorkDurationInfo?.weekYoY,
              },
            ],
          },
        ]
        this.workDurationData.secondaryDataList = [
          {
            label: '昨日平均高峰出车时长占比',
            value: ((data?.operateAttitude?.yesterdayAveBusyDurationInfo?.value || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '查询日期当天，高峰出车时长占总出车时长比例',
            ratioList: [
              {
                name: '日环比',
                value: data?.operateAttitude?.yesterdayAveBusyDurationInfo?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.operateAttitude?.yesterdayAveBusyDurationInfo?.weekYoY,
              },
            ],
          },
          {
            label: '昨日平均服务时长占比',
            value: ((data?.operateAttitude?.yesterdayAveServiceDurationInfo?.value || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '查询日期当天，服务时长占总出车时长比例',
            ratioList: [
              {
                name: '日环比',
                value: data?.operateAttitude?.yesterdayAveServiceDurationInfo?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.operateAttitude?.yesterdayAveServiceDurationInfo?.weekYoY,
              },
            ],
          },
        ]

        // 昨日出车时长分布
        this.workDurationDistributionData.dataUpdateTime = data?.updateTime || ''
        this.workDurationDistributionData.data = (data?.operateAttitude?.yesterdayAveWorkDurationDistribution || WORK_DURATION_LIST.map((item) => ({ name: item.name }))).map((item, index) => {
          return {
            name: item.levelName || item.name || '',
            data: [
              {
                ratio: item.proportion || 0,
                data: [
                  {
                    type: 'number',
                    name: '车辆数',
                    value: item.value || 0,
                    clickCallback: () => this.toVehicleOperateList({
                      yesterdayWorkDuration: index + 1,
                    }),
                  },
                  {
                    type: 'ratio',
                    name: '占比',
                    value: item.proportion || 0,
                  },
                ],
              },
            ],
          }
        })

        // 平均TPH
        this.tphData.dataUpdateTime = data?.updateTime || ''
        this.tphData.primaryDataList = [
          {
            label: '昨日平均TPH(单/小时)',
            value: data?.operateEfficiency?.yesterdayAveTPH?.value || '--',
            unit: '',
            tooltip: `昨日平均TPH = 查询日期当日，总完单量/出车车辆总出车时长，计算结果展示对应等级：<br/>
            极低：【0，0.5）<br/>
            较低：【0.5，1）<br/>
            一般：【1，1.5）<br/>
            较高：【1.5，2）<br/>
            极高：2以上`,
            ratioList: [
              {
                name: '日环比',
                value: data?.operateEfficiency?.yesterdayAveTPH?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.operateEfficiency?.yesterdayAveTPH?.weekYoY,
              },
            ],
          },
          {
            label: '本周平均TPH(单/小时)',
            value: data?.operateEfficiency?.weekAveTPH?.value || '--',
            unit: '',
            tooltip: `本周平均TPH = 查询日期当周，总完单量/出车车辆总出车时长，计算结果展示对应等级：<br/>
            极低：【0，0.5）<br/>
            较低：【0.5，1）<br/>
            一般：【1，1.5）<br/>
            较高：【1.5，2）<br/>
            极高：2以上`,
            ratioList: [],
          },
          {
            label: '本月平均TPH(单/小时)',
            value: data?.operateEfficiency?.monthAveTPH?.value || '--',
            unit: '',
            tooltip: `本月平均TPH=查询日期当月，总完单量/出车车辆总出车时长，计算结果展示对应等级：<br/>
            极低：【0，0.5）<br/>
            较低：【0.5，1）<br/>
            一般：【1，1.5）<br/>
            较高：【1.5，2）<br/>
            极高：2以上`,
            ratioList: [],
          },
        ]

        // 平均IPH
        this.iphData.dataUpdateTime = data?.updateTime || ''
        this.iphData.primaryDataList = [
          {
            label: '昨日平均IPH(元/小时)',
            value: data?.operateEfficiency?.yesterdayAveIPH?.value || '--',
            unit: '',
            tooltip: `昨日平均IPH = 查询日期当期，车辆收入总和/出车车辆总出车时长，计算结果展示对应等级：<br/>
            *单个车辆总收入包括司机抽佣金额+活动奖励收入+人工调账金额+司机罚款+取消费<br/>
            极低：【0，30）<br/>
            较低：【30，60）<br/>
            一般：【60，90）<br/>
            较高：【90，120）<br/>
            极高：120以上`,
            ratioList: [
              {
                name: '日环比',
                value: data?.operateEfficiency?.yesterdayAveIPH?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.operateEfficiency?.yesterdayAveIPH?.weekYoY,
              },
            ],
          },
          {
            label: '本周平均IPH(元/小时)',
            value: data?.operateEfficiency?.weekAveIPH?.value || '--',
            unit: '',
            tooltip: `本周平均IPH=查询日期当周，车辆收入总和/出车车辆总出车时长，计算结果展示对应等级：<br/>
            *单个车辆总收入包括司机抽佣金额+活动奖励收入+人工调账金额+司机罚款+取消费<br/>
            极低：【0，30）<br/>
            较低：【30，60）<br/>
            一般：【60，90）<br/>
            较高：【90，120）<br/>
            极高：120以上
            `,
            ratioList: [],
          },
          {
            label: '本月平均IPH(元/小时)',
            value: data?.operateEfficiency?.monthAveIPH?.value || '--',
            unit: '',
            tooltip: `本月平均IPH=查询日期当月，车辆收入总和/出车车辆总出车时长，计算结果展示对应等级：<br/>
            *单个车辆总收入包括司机抽佣金额+活动奖励收入+人工调账金额+司机罚款+取消费<br/>
            极低：【0，30）<br/>
            较低：【30，60）<br/>
            一般：【60，90）<br/>
            较高：【90，120）<br/>
            极高：120以上`,
            ratioList: [],
          },
        ]

        // 昨日TPH分布
        this.tphDistributionData.dataUpdateTime = data?.updateTime || ''
        this.tphDistributionData.data = (data?.operateEfficiency?.yesterdayTPHDistribution || TPH_LIST.map((item) => ({ name: item.name }))).map((item, index) => {
          return {
            name: item.levelName || item.name || '',
            data: [
              {
                ratio: item.proportion || 0,
                data: [
                  {
                    type: 'number',
                    name: '车辆数',
                    value: item.value || 0,
                    clickCallback: () => this.toVehicleOperateList({
                      yesterdayTPH: index + 1,
                    }),
                  },
                  {
                    type: 'ratio',
                    name: '占比',
                    value: item.proportion || 0,
                  },
                ],
              },
            ],
          }
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mb16 {
  margin-bottom: 16px;
}
.mt24 {
  margin-top: 24px;
}
.module-title {
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: #3D3D3D;
}
</style>
